/**
 * Infinite-scroll helpers for the paged job lists (Home, Jobs).
 *
 * The search sorts by posting date (day precision) and score, with no unique tie-breaker, so
 * tied jobs can come back in a different order from one page request to the next: a job can
 * show up on two pages while another is skipped. Flutter appends pages as they come, which
 * listed the repeat twice (and gave React duplicate keys). A repeat is dropped here; a skipped
 * job can only come back once the backend sort is stable.
 */
export function appendNewJobs<T extends { displayId?: string; id?: string }>(current: T[], page: T[]): T[] {
  const seen = new Set(current.map(jobKey).filter(Boolean));
  const added = page.filter((job) => {
    const key = jobKey(job);
    if (!key) return true;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
  return added.length === page.length ? [...current, ...page] : [...current, ...added];
}

function jobKey(job: { displayId?: string; id?: string }): string {
  return job.displayId || job.id || '';
}
